import React, { useState, useEffect, useRef } from "react";
import { images } from "../../config/images";
import { useNavigate } from "react-router-dom";
import {
    Grid,
    Container,
    Typography,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
    TableHead,
    Modal,
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import SearchIcon from "@mui/icons-material/Search";

const DispatchPrintHistory = () => {
    const navigate = useNavigate();
    const data = [
        { date_of_printing: "01", time_of_printing: "09:35:59", shift: "Shift-I", orderId: "DEA0010107", custumer_name: "JSW Steel Limited", box_no: "B 10", no_of_prints: "01", user: "Zeel" },
        { date_of_printing: "02", time_of_printing: "11:59:15", shift: "Shift-II", orderId: "DEA0010108", custumer_name: "Ideal Electrify Shop LLp", box_no: "B 11", no_of_prints: "01", user: "Maulik" },
        { date_of_printing: "03", time_of_printing: "10:45:15", shift: "Shift-III", orderId: "DEA0010109", custumer_name: "Ceylon Electricity Board", box_no: "B 12", no_of_prints: "01", user: "Parth" },
        { date_of_printing: "04", time_of_printing: "10:35:40", shift: "Shift-IV", orderId: "DEA0010110", custumer_name: "Astral", box_no: "B 13", no_of_prints: "02", user: "Kumar" },
    ];

    const initiallValue = {
        date_of_printing: "",
        time_of_printing: "",
        shift: "",
        order_id: "",
        custumer_name: "",
        box_no: "",
        no_of_prints: "",
        user: ""
    };
    const [searchText, setSearchText] = useState(initiallValue);
    const [getHistoryData, setGetHistoryData] = useState([]);
    const [Count, setCount] = useState("");
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [isDeletePopupOpen, setDeletePopup] = useState();

    const handleSearchData = async (e) => {
        const { name, value } = e.target;
        setSearchText({ ...searchText, [name]: value });
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleCancelDelete = () => {
        setDeletePopup(false); // Close popup without deleting
    };

    return (
        <>
            <div className="containerWrap">
                <Container maxWidth="xxl">
                    <div className="packingHeader-wrap">
                        <div className="packingTitle-wrap">
                            <KeyboardBackspaceIcon
                                onClick={() => navigate("/dispatch-summary")}
                                className="backArrow"
                            />
                            <Typography
                                variant="h5"
                                className="packingTitle"
                                gutterBottom
                                onClick={() => navigate(-1)}
                            >
                                Dispatch Print History
                            </Typography>
                        </div>
                    </div>

                    <div className="dispatchSummaryTable">
                        <Table>
                            <TableHead className="dispatchTable-head">
                                <TableRow className="dispatchTable-headRow">
                                    <TableCell className="dispatchTable-headRow-cell" >Date of Printing</TableCell>
                                    <TableCell className="dispatchTable-headRow-cell" >Time of Printing</TableCell>
                                    <TableCell className="dispatchTable-headRow-cell">Shift</TableCell>
                                    <TableCell className="dispatchTable-headRow-cell" style={{ width: "20px" }}>Order Id</TableCell>
                                    <TableCell className="dispatchTable-headRow-cell" >Customer Name</TableCell>
                                    <TableCell className="dispatchTable-headRow-cell" >Box No</TableCell>
                                    <TableCell className="dispatchTable-headRow-cell" >No. of Prints</TableCell>
                                    <TableCell className="dispatchTable-headRow-cell" >User</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="search-table-row">
                                        <SearchIcon className="search-icon" />
                                        <input
                                            type="search"
                                            placeholder="Date of Printing"
                                            name="date_of_printing"
                                            value={searchText.date_of_printing}
                                            onChange={handleSearchData}
                                        />
                                    </TableCell>
                                    <TableCell className="search-table-row">
                                        <SearchIcon className="search-icon" />
                                        <input
                                            type="search"
                                            placeholder="Time of Printing"
                                            name="time_of_printing"
                                            value={searchText.time_of_printing}
                                            onChange={handleSearchData}
                                        />
                                    </TableCell>
                                    <TableCell className="search-table-row">
                                        <SearchIcon className="search-icon" />
                                        <input
                                            type="search"
                                            placeholder="Shift"
                                            name="shift"
                                            value={searchText.shift}
                                            onChange={handleSearchData}
                                        />
                                    </TableCell>
                                    <TableCell className="search-table-row">
                                        <SearchIcon className="search-icon" />
                                        <input
                                            type="search"
                                            placeholder="Order Id"
                                            name="order_id"
                                            value={searchText.order_id}
                                            onChange={handleSearchData}
                                        />
                                    </TableCell>
                                    <TableCell className="search-table-row">
                                        <SearchIcon className="search-icon" />
                                        <input
                                            type="search"
                                            placeholder="Customer Name"
                                            name="custumer_name"
                                            value={searchText.custumer_name}
                                            onChange={handleSearchData}
                                        />
                                    </TableCell>
                                    <TableCell className="search-table-row">
                                        <SearchIcon className="search-icon" />
                                        <input
                                            type="search"
                                            placeholder="Box No"
                                            name="box_no"
                                            value={searchText.box_no}
                                            onChange={handleSearchData}
                                        />
                                    </TableCell>
                                    <TableCell className="search-table-row">
                                        <SearchIcon className="search-icon" />
                                        <input
                                            type="search"
                                            placeholder="No of prints"
                                            name="no_of_prints"
                                            value={searchText.no_of_prints}
                                            onChange={handleSearchData}
                                        />
                                    </TableCell>
                                    <TableCell className="search-table-row">
                                        <SearchIcon className="search-icon" />
                                        <input
                                            type="search"
                                            placeholder="User"
                                            name="user"
                                            value={searchText.user}
                                            onChange={handleSearchData}
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody className="dispatchTable-body">
                                {data.map((row, index) => (
                                    <TableRow className="dispatchTable-bodyRow" key={index}>
                                        <TableCell className="dispatchTable-bodyRow-cell">{row.date_of_printing}</TableCell>
                                        <TableCell className="dispatchTable-bodyRow-cell">{row.time_of_printing}</TableCell>
                                        <TableCell className="dispatchTable-bodyRow-cell"> {row.shift}</TableCell>
                                        <TableCell className="dispatchTable-bodyRow-cell">{row.orderId} </TableCell>
                                        <TableCell className="dispatchTable-bodyRow-cell">{row.custumer_name} </TableCell>
                                        <TableCell className="dispatchTable-bodyRow-cell">{row.box_no} </TableCell>
                                        <TableCell className="dispatchTable-bodyRow-cell">{row.no_of_prints} </TableCell>
                                        <TableCell className="dispatchTable-bodyRow-cell" style={{display: "flex",
                                            justifyContent: "space-around",
                                            gap: "40px",
                                            alignItems: "center"
                                        }}>{row.user}
                                            <img src={images.eyeIcon} onClick={() => { setDeletePopup(!isDeletePopupOpen) }} />

                                        </TableCell>
                                    </TableRow>
                                ))}

                            </TableBody>
                        </Table>
                    </div>
                    <TablePagination
                        className="table-pagination"
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={Count}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />

                </Container>
            </div>
        </>
    )
}
export default DispatchPrintHistory;
